module.exports = __webpack_public_path__ + "img/ePay_logo.4fe6e46a.svg";